import React, { useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Placeholder page for routes not yet built (e.g. /collection/:slug, /about, etc.)
 */
export const Placeholder = ({ title }) => {
  const location = useLocation();
  const params = useParams();

  // Try to derive a nice label
  const derived =
    title ||
    (params.slug
      ? params.slug
          .split("-")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ")
      : location.pathname
          .replace(/^\//, "")
          .split("-")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ")) ||
    "Page";

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  return (
    <main
      data-testid="placeholder-page"
      className="min-h-[70vh] editorial-container flex flex-col items-center justify-center text-center py-24"
    >
      <span className="h-px w-12 bg-brand-gold/60 mb-8" />
      <p
        data-testid="placeholder-eyebrow"
        className="font-sans text-[10px] uppercase tracking-[0.4em] text-brand-cream/40 mb-4"
      >
        {derived}
      </p>
      <h1 className="font-serif font-light text-5xl md:text-6xl text-brand-cream max-w-2xl">
        Coming <span className="italic text-brand-gold">soon</span>.
      </h1>
      <p className="mt-6 max-w-md font-sans text-sm text-brand-cream/60 leading-relaxed">
        This chapter is being curated. In the meantime, browse the rest of the
        story - or message us on WhatsApp.
      </p>
      <Link
        to="/"
        data-testid="placeholder-back-home"
        className="mt-10 group inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.28em] text-brand-cream/70 hover:text-brand-gold transition-colors"
      >
        <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
        Back to Home
      </Link>
    </main>
  );
};

export default Placeholder;
